export default __webpack_public_path__ + "static/media/agile-warning-image.a8c46c20.svg";